import React, { ReactElement } from 'react';
import { Row } from '../../../../../../ui';
import { DetailsFormSection as Section } from '../DetailsFormSection';
import { FirstName } from '../../../../../auth/shared/form-fields/FirstName';
import { LastName } from '../../../../../auth/shared/form-fields/LastName';
import { PhoneNumber } from '../fields/PhoneNumber';
import { Address } from '../fields/Address';
import { City } from '../fields/City';
import { State } from '../fields/State';
import { ZipCode } from '../fields/ZipCode';
import { useTranslation } from '../../../../i18n/translate/useTranslation';

export interface IPersonalDetailsProps {
	emailField: ReactElement;
}
export interface IPersonalDetailsFormData {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	address: string;
	city: string;
	state: string;
	zipCode: string;
}

export const PersonalDetails = ({ emailField }: IPersonalDetailsProps) => {
	const { t } = useTranslation();

	return (
		<Section title={t('web_parking_details_personal_details_header')}>
			<Row>
				<FirstName />
				<LastName />
			</Row>
			<Row>
				{!!emailField && emailField}
				<PhoneNumber />
			</Row>
			<Row>
				<Address />
				<City />
			</Row>
			<Row>
				<State />
				<ZipCode />
			</Row>
		</Section>
	);
};
